export default "__VITE_ASSET__DoOyHP09__"